// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3FxDe","content":"LoadingAlert_content__1uDDA"};